export const IN_STORE_SIGNUP_REQUEST = 'IN_STORE_SIGNUP_REQUEST'
export const IN_STORE_SIGNUP_SUCCESS = 'IN_STORE_SIGNUP_SUCCESS'
export const IN_STORE_SIGNUP_FAILURE = 'IN_STORE_SIGNUP_FAILURE'
export const SELECT_RETAILERS_GROUP = 'SELECT_RETAILERS_GROUP'
export const FETCH_RETAILERS_GROUP_ERROR = 'FETCH_RETAILERS_GROUP_ERROR'
export const RESET_IN_STORE_SIGNUP_FORM = 'RESET_IN_STORE_SIGNUP_FORM'
